<ng-container *ngIf="unableToClickSelectMeal" [ngTemplateOutlet]="disabledMeal"> </ng-container>
<ng-container
  *ngIf="unableToClickSelectMeal !== true && isDeleteBtnDisplay !== true && isBabyMeal !== true"
  [ngTemplateOutlet]="unselectedMeal"
>
</ng-container>
<ng-container *ngIf="unableToClickSelectMeal !== true && isDeleteBtnDisplay" [ngTemplateOutlet]="selectedMeal">
</ng-container>
<ng-container *ngIf="isBabyMeal" [ngTemplateOutlet]="babyMeal"> </ng-container>

<ng-template #disabledMeal>
  <div class="c-status-display" [ngClass]="{ 'is-selected': isDisplaySelectedMealIcon || isDisplayMealStatus }">
    <span
      class="c-status-display__body"
      [ngClass]="{
        'c-status-display__body--has-mark': isDisplaySelectedMealIcon,
        'c-status-display__body--has-status': isDisplayMealStatus
      }"
    >
      <span class="c-status-display__text">
        <span *ngIf="inFlightMealType !== ''" class="c-status-display__text-lead" [innerHTML]="inFlightMealType"></span>
        <span
          class="c-status-display__text-label c-status-display-button__text-label--em"
          [innerHTML]="inFlightMealName"
        ></span>
      </span>
      <span *ngIf="isDisplaySelectedMealIcon" class="c-status-display__mark"
        ><img src="assets/images/icon_check_primary_24.svg" width="24" height="24" alt="check"
      /></span>
      <span
        *ngIf="isDisplayMealStatus"
        class="c-status-display__status c-status-display__status--gray60"
        [innerHTML]="serviceStatus | staticMsg"
      ></span>
    </span>
  </div>
</ng-template>

<ng-template #unselectedMeal>
  <button type="button" class="c-status-display-button" id="adult-meal-{{ uuid }}" (click)="onSelectMenu()">
    <span class="c-status-display-button__body">
      <span class="c-status-display-button__text">
        <span
          class="c-status-display-button__text-label c-status-display-button__text-label--em"
          [innerHTML]="inFlightMealName"
        >
        </span>
      </span>
    </span>
  </button>
</ng-template>

<ng-template #selectedMeal>
  <button
    type="button"
    class="c-status-display-btn-selected"
    id="paid-exclusive-dining-{{ uuid }}"
    [attr.aria-label]="'reader.deleteMeal' | staticMsg"
  >
    <span
      class="c-status-display-btn-selected__body"
      [ngClass]="{ 'c-status-display-btn-selected__body--has-status': !!serviceAmount }"
    >
      <span class="c-status-display-btn-selected__text">
        <span *ngIf="inFlightMealType !== ''" class="c-status-display__text-lead" [innerHTML]="inFlightMealType"></span>
        <span
          class="c-status-display-btn-selected__text-label c-status-display-btn-selected__text-label--em"
          [innerHTML]="inFlightMealName"
        >
        </span>
      </span>
      <span
        *ngIf="!!serviceAmount"
        class="c-status-display-btn-selected__status c-status-display-btn-selected__status--em"
      >
        <span class="c-amount c-amount--price"
          ><span class="c-amount__num c-amount__num--fs20" [innerHTML]="serviceAmount | amountFormat"></span
        ></span>
      </span>
    </span>
    <span
      class="c-status-display-btn-selected__is-delete"
      *ngIf="isDeleteBtnDisplay"
      (click)="onClearMealSelection(appliedMeal)"
    ></span>
  </button>
</ng-template>

<ng-template #babyMeal>
  <div
    class="c-form-element-checkbox-button01"
    [ngClass]="{ 'is-disabled': isDisabledCheckBox, 'is-selected': isHighlightBorder }"
  >
    <div class="c-form-element-checkbox-button01__wrap">
      <input
        type="checkbox"
        name="{{ 'checkbox-' + traveler.id + '-' + flight.id }}"
        id="{{ 'checkbox-' + traveler.id + '-' + flight.id }}"
        [(ngModel)]="isBabyMealChecked"
        (change)="onChangeBabyMeal()"
        class="c-form-element-checkbox-button01__input"
        *ngIf="isDisplayBabyMealCheckBox"
        [disabled]="isDisabledCheckBox"
      />
      <label for="{{ 'checkbox-' + traveler.id + '-' + flight.id }}" class="c-form-element-checkbox-button01__label">
        <span class="c-form-element-checkbox-button01__text">
          <span class="c-form-element-checkbox-button01__text-label" [innerHTML]="babyMealLabel"></span>
        </span>
        <span *ngIf="isDisplayBabyMealCheckBox" class="c-form-element-checkbox-button01__check"> </span>
        <span
          *ngIf="babyMealStatus !== 'hidden'"
          class="c-status-display__status c-status-display__status--gray60"
          [innerHTML]="babyMealStatus | staticMsg"
        ></span>
      </label>
    </div>
  </div>
</ng-template>
